var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlecheBlanc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_431",
    "data-name": "Groupe 431",
    transform: "translate(-1090 -1706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_110",
    "data-name": "Groupe 110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_103",
    "data-name": "Groupe 103",
    transform: "translate(908 1034)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 48,
    height: 48,
    transform: "translate(182 672)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M41.984,35.446,34.593,28l-1.51,1.458L38.031,34.4H25.224v2.062H38.067l-4.983,4.946,1.51,1.458,7.39-7.4-.011-.011Z",
    transform: "translate(1080.776 1694.422)",
    fill: "#263984"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheBlanc);
export default __webpack_public_path__ + "static/media/fleche-blanc.0197ef71.svg";
export { ForwardRef as ReactComponent };